import { z } from 'zod'
import type { UserSessionERPSettings } from '../../models/UserSessionERPSettings'

export const UserSessionERPSettingsDTO = z.object({
  allow_simultaneous_access: z.boolean()
})

export type UserSessionERPSettingsDTO = z.infer<typeof UserSessionERPSettingsDTO>

export function mapUserSessionERPSettingsToDTO (model: UserSessionERPSettings): UserSessionERPSettingsDTO {
  return {
    allow_simultaneous_access: model.allowSimultaneousAccess
  }
}

export function mapDTOToUserSessionERPSettings (dto: UserSessionERPSettingsDTO): UserSessionERPSettings {
  return {
    allowSimultaneousAccess: dto.allow_simultaneous_access
  }
}
